import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalPGAgreement, principalIsPG, applicantSameAsPrincipal },
} = loanFormModel;

export class PrincipalPGAgreementValidation implements ValidationSchema {
  public name = principalPGAgreement.name;
  public label = principalPGAgreement.label;
  public dependsOn: string[] = [
    principalIsPG.name,

    applicantSameAsPrincipal.name,
  ];
  public type = 'boolean';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(principalIsPG: string, applicantSameAsPrincipal: string, schema) {
    if (principalIsPG === 'Yes' && applicantSameAsPrincipal === 'Yes') {
      return schema
        .required(principalPGAgreement.requiredErrorMsg)
        .oneOf([true], principalPGAgreement.requiredErrorMsg);
    }
    return schema;
  }
}
export default new Validation(new PrincipalPGAgreementValidation());
